import {
  AppState,
  Auth0Provider as Auth0ReactProvider,
} from "@auth0/auth0-react";
import React, { ReactNode } from "react";

interface Auth0ConfigType {
  domain: string;
  clientId: string;
  audience: string;
  redirectUri: string;
}

interface Auth0ProviderProps {
  children: ReactNode;
}

const SCOPE = "openid profile email phone";
const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

export const Auth0Provider = ({
  children,
}: Auth0ProviderProps): JSX.Element => {
  if (!domain || !clientId || !audience) {
    // TODO: Throw error after migration
    return children as JSX.Element;
  }

  const auth0Config: Auth0ConfigType = {
    domain,
    clientId,
    audience,
    redirectUri: `${globalThis.location.origin}/auth0-callback`,
  };

  const onRedirectCallback = (appState?: AppState): void => {
    globalThis.history.replaceState(
      {},
      document.title,
      appState?.returnTo || globalThis.location.pathname
    );
  };

  return (
    <Auth0ReactProvider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        audience: auth0Config.audience,
        scope: SCOPE,
        prompt: "login", // This should force users to always enter their email and password
      }}
      cacheLocation="memory"
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0ReactProvider>
  );
};

export default Auth0Provider;
